import { createAsyncThunk } from '@reduxjs/toolkit';
import { getProfileApi, loginApi } from '@src/api';
import { oliveApi } from '@src/api';
import { LoginForm } from '@src/api/auth/auth';

const login = createAsyncThunk(
  'login',
  async (data: LoginForm, { rejectWithValue }) => {
    try {
      oliveApi.tokenManager.clear();
      const response = await loginApi(data);

      oliveApi.tokenManager.save(response.result.token);

      return response.result;
    } catch (err) {
      throw rejectWithValue(err);
    }
  }
);

const stayLogin = createAsyncThunk(
  'stayLogin',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getProfileApi();
      return response.result.data;
    } catch (err) {
      throw rejectWithValue(err);
    }
  }
);

export { login, stayLogin };
